import React from "react";
import { Routes, Route } from "react-router-dom";
import Login from "./pages/auth/Login";
import Welcome from "./pages/auth/Welcome";
import PageReegister from "./pages/auth/Register";
import { RegisterForm, StateParamWrapper } from "./pages/auth/RegisterForm";
import AccountCreated from "./pages/AccountCreated/AccountCreated";
import Page404 from "./pages/Page404";
import ResetPassword from "./pages/auth/ResetPassword";
import SetNewPassword from "./pages/auth/SetNewPassword";
import PageInvest from "./pages/PageInvest/PageInvest";
import PageInvestments from "./pages/PageInvestments/PageInvestments";
import PageMovements from "./pages/PageMovements/PageMovements";
import { Dashboard } from "./pages/Dashboard/Dashboard";
import PageDashboard from "./pages/PageDashboard/PageDashboard";

const MainRoutes = () => {
  return (
    <Routes>
      <Route path="/" element={<Dashboard />}>
        <Route path="dashboard" element={<PageDashboard />} />
        <Route path="invertir" element={<PageInvest />} />
        <Route path="mi-portafolio" element={<PageInvestments />} />
        <Route path="mis-movimientos" element={<PageMovements />} />
      </Route>

      <Route path="/welcome" element={<Welcome />} />
      <Route path="/reset-password" element={<ResetPassword />} />
      <Route path="/new-password/:slug" element={<SetNewPassword />} />
      <Route path="/login" element={<Login />} />
      <Route path="/register" element={<PageReegister />} />
      <Route path="/register/:code" element={<PageReegister />} />
      <Route path="/register/cuenta-creada" element={<AccountCreated />} />

      <Route element={<StateParamWrapper />}>
        <Route path="/register/form" element={<RegisterForm />} />
        <Route path="/register/form/:code" element={<RegisterForm />} />
      </Route>

      <Route path="*" element={<Page404 />} />
    </Routes>
  );
};

export default MainRoutes;
